module.exports = __webpack_public_path__ + "img/Fondo2.e57ac9ce.jpg";